export type SearchFilters = {
  location: string[]
  facilityType: string[]
  date: string
  startTime: string
  endTime: string
  numberOfPeople: string[]
}

export const EMPTY_FILTERS: SearchFilters = {
  location: [],
  facilityType: [],
  date: "",
  startTime: "",
  endTime: "",
  numberOfPeople: [],
}

const OFFICES_KEYWORDS = ["משרדים", "offices"]
const MEETING_ROOM_KEYWORDS = ["חדרי ישיבות", "חדר ישיבות", "meeting"]
const EVENTS_KEYWORDS = ["אירועים", "כנסים", "events", "conferences"]

export function isMeetingRoom(facilityType?: string) {
  return MEETING_ROOM_KEYWORDS.some((kw) => facilityType?.toLowerCase().includes(kw))
}

export function isOffice(facilityType?: string) {
  return OFFICES_KEYWORDS.some((kw) => facilityType?.toLowerCase().includes(kw))
}

export function isEventsConferences(facilityType?: string) {
  return EVENTS_KEYWORDS.some((kw) => facilityType?.toLowerCase().includes(kw))
}

export function getCtaLabel(facilityType?: string, fallback?: string) {
  return isMeetingRoom(facilityType) ? "להזמנה אונליין" : fallback || "מידע נוסף"
}

export const TIME_SLOTS: string[] = (() => {
  const slots: string[] = []
  for (let h = 7; h <= 22; h++) {
    slots.push(`${h.toString().padStart(2, "0")}:00`)
    if (h < 22) slots.push(`${h.toString().padStart(2, "0")}:30`)
  }
  return slots
})()

export const START_TIME_SLOTS = TIME_SLOTS.slice(0, -1)

export function formatDurationHebrew(startTime: string, endTime: string): string {
  const [sh, sm] = startTime.split(":").map(Number)
  const [eh, em] = endTime.split(":").map(Number)
  const hours = eh - sh + (em - sm) / 60
  if (hours <= 0) return ""
  if (hours === 0.5) return "חצי שעה"
  if (hours === 1) return "שעה אחת"
  if (hours === 1.5) return "שעה וחצי"
  if (hours === 2) return "שעתיים"
  if (hours === 2.5) return "שעתיים וחצי"
  const isWhole = hours % 1 === 0
  return `${isWhole ? hours : hours.toFixed(1)} שעות`
}

export const ITEMS_PER_PAGE = 6
